// @flow
import React from 'react';
import { connect } from 'react-redux';
import { MdSearch } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import type { OMNISEARCH_RESPONSE_TYPE} from '../../types/omnisearch';
import { OMNISEARCH_RESULT_TYPES } from '../Omnisearch';

import { OmniSearch } from '../../api/index';
import { RenderTypeahead } from '../FieldRenderer';
import AsyncTypeahead from '../Typeahead/async';
import OmnisearchResult from '../OmnisearchResult';
import TypeaheadLoadingResults from '../OmnisearchLoadingResults';
import { Search } from '../CommonTexts';

import * as selectors from '../../reducers';


type StopsTypeaheadPropTypes = {
  fetchStops: Function,
  onSelect: Function,
  routeType?: 'going' | 'returning',
};


const CustomRenderItem = (item: Object, isHighlighted: boolean) => (
  <OmnisearchResult
    {...item}
    isSelected={isHighlighted}
    size="small"
  />
);

const StopsTypeahead = ({
  fetchStops,
  onSelect,
  routeType,
}: StopsTypeaheadPropTypes) => (
  <div>
    <AsyncTypeahead
      inputDebounce={200}
      renderLoading={() => <TypeaheadLoadingResults size="small" count={3} />}
      fetchItems={fetchStops}
      renderItem={CustomRenderItem}
      onChange={el => el != null && onSelect(el)}
      inputProps={{
        Icon: MdSearch,
        iconPosition: 'right',
        placeholder: Search(i18n.t('labels.stops'), 2),
        size: 'small',
      }}
    />
  </div>
);


const transformStopsTypeahead = (response: OMNISEARCH_RESPONSE_TYPE, routeType: String) => {
  const results = response.results.filter(res => res.route_type === routeType);

  return results.map((result) => {
    const newResult = {
      ...result,
      value: `${result.name}`,
      textIndex: result.text,
    };

    return {
      ...newResult,
      label: result.name,
      routeName: result.route_name,
      group_type: 'route_stop',
      target_role: 'route_stop',
      base_model_id: newResult.id,
    };
  });
};

export default connect(
  (state, ownProps) => {
    const token = selectors.getToken(state);
    const profile = selectors.getProfileOfType(state, 'admin');

    const fetchStops = (text: string) => OmniSearch.custom.search({
      token,
      filters: {
        text,
        school: profile ? profile.school : -1,
        result_type: OMNISEARCH_RESULT_TYPES.routeStop,
      },
    }).then(value => transformStopsTypeahead(value, ownProps.routeType));

    return {
      fetchStops,
      onSelect(o) {
        ownProps.onSelect(o);
      },
    };
  },
)(StopsTypeahead);



// WEBPACK FOOTER //
// ./src/scripts/components/StopsTypeahead/index.jsx